import Collapse from 'react-bootstrap/Collapse';
import bn from '../../utils/bemnames';
import ErrorBoundary from './ErrorBoundary';
const bem = bn.create('faqhelp');
const bem2 = bn.create('collapseCard');

type ControlledCollapseComponentProps = {
  isOpen: boolean;
  Heading: string;
  children: React.ReactNode;
  onIsOpenTab: (isOpen: boolean) => void;
  disable?: boolean;
  isCardStyle?: boolean;
  headerNote?: string;
};

const ControlledCollapseComponent = ({
  isOpen,
  Heading,
  children,
  onIsOpenTab,
  disable = false,
  isCardStyle = false,
  headerNote,
}: ControlledCollapseComponentProps) => {
  return (
    <ErrorBoundary>
      <div className={isCardStyle ? bem2.b('') : bem.b('')}>
        <div className="row definitionMain">
          <div onClick={() => onIsOpenTab(!isOpen)} className={isOpen ? 'collapse-card-header' : 'faqcardheader'}>
            <div className="mb-0 w-100">
              <div
                className="col-12 col-md-12 col-sm-12 btn btn-link text-start btnOutlineNone p-3"
                style={{
                  cursor: disable ? 'auto' : 'pointer',
                }}
                onClick={(e) => {
                  e.preventDefault();
                  !disable && onIsOpenTab(!isOpen);
                }}
                aria-controls="collapse-text"
                aria-expanded={isOpen}
              >
                <h3>{Heading}</h3>
              </div>
            </div>

            {headerNote !== undefined && isOpen === false && <p className="lable-subscription">{headerNote}</p>}

            <span
              onClick={() => !disable && onIsOpenTab(!isOpen)}
              className={
                isOpen ? 'iconUpDownColor text-primary bi bi-dash p-3' : 'iconUpDownColor text-primary bi bi-plus p-3'
              }
            />
          </div>
          <Collapse in={isOpen}>
            <div id="collapse-text" className="pb-2 pt-2 cardBody">
              {children}
            </div>
          </Collapse>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default ControlledCollapseComponent;
